import { render } from "./XeniaCoceaPage.vue?vue&type=template&id=09654b7e"
import script from "./XeniaCoceaPage.vue?vue&type=script&lang=js"
export * from "./XeniaCoceaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__